import { Children, type ReactNode } from "react";
import { View, type StyleProp, type ViewStyle } from "react-native";

export type DialogActionsProps = {
  children: ReactNode;
  /** Gap between sibling actions. Defaults to the standard dialog spacing. */
  gap?: number;
  style?: StyleProp<ViewStyle>;
  testID?: string;
};

/**
 * Shared action layout for dialog footers and multi-step dialog controls.
 *
 * A lone action is stacked so the canonical primary button can fill the
 * dialog width. Multiple actions stay in a row so paired cancel/confirm
 * controls retain equal widths.
 */
export function DialogActions({
  children,
  gap = 12,
  style,
  testID,
}: DialogActionsProps) {
  const isSingleAction = Children.count(children) <= 1;

  return (
    <View
      testID={testID}
      style={[
        {
          width: "100%",
          flexDirection: isSingleAction ? "column" : "row",
          ...(isSingleAction ? { alignItems: "stretch" as const } : null),
          gap,
          marginTop: 8,
        },
        style,
      ]}
    >
      {children}
    </View>
  );
}

export default DialogActions;
